<div class="left-border" [class]="mode">
    <div class="alert-msg-wrap">
        <div class="icon" [class]="mode" [ngSwitch]="mode">
            <i aria-hidden="true" class="material-icons-round" *ngSwitchCase="'error'">warning</i>
            <i aria-hidden="true" class="material-icons" *ngSwitchCase="'info'">info</i>
            <i aria-hidden="true" class="material-icons" *ngSwitchCase="'success'">check_circle</i>
        </div>
        <div class="message-wrap">
            <h4 [attr.role] = "mode === 'error'? 'alert':''" [hidden]="!title" class="title">{{title}}</h4>
            <span [attr.role] = "mode === 'error'? 'alert':''" [hidden]="!message" class="message">{{message}}</span>
        </div>
    </div>
</div>